import React from 'react';
import { Footer } from '../components/HomePage';
import HowItWorksHeader from '../components/HowItWorks/HowItWorksHeader';
import ProfileVerification from '../components/MyProfile/Verification/ProfileVerification';

function ProfileVerificationPage() {
  return (
    <>
      <ProfileVerification />
      <Footer />
    </>
  );
}

export default ProfileVerificationPage;